module.exports = __webpack_public_path__ + "static/treenihetki-7541dafd0665be3f070f2ded7e1f4555.jpg";